<template>
  <div>
    <el-dialog :title="propData.status ? '编辑品类' : '添加品类'" :visible.sync="addDialogVisible" class="imgbox" width="800px"
      :before-close="resetForm" :append-to-body="true" :close-on-click-modal="false">
      <el-form resetFields label-width="130px" ref="ruleForm" :rules="rules" :model="form">

        <el-form-item label="品类名称" prop="categoryName">
          <el-input v-model.trim="form.categoryName" maxlength="20" autocomplete="off" placeholder="请输入品类名称"></el-input>
        </el-form-item>

        <el-form-item prop="language" label="语言">
            <el-select v-model="form.language"
              placeholder="请选择语言">
              <el-option v-for="item in languageOpts" :key="item.language" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

        <el-form-item required label="品类图标" prop="fileUrl">
          <div style="display: flex;align-items: flex-end;">
            <el-upload :data="data" :on-success="(res, file) => { handleImgSuccess(res, file) }" class="avatar-uploader"
              :before-upload="beforeImgUp" action="/api/paas-platform/file-service/v1/file/upload/fileUpload"
              accept="image/png">
              <el-image v-if="form.fileUrl" :src="form.fileUrl" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon" />
            </el-upload>
            <span style="font-size: 13px;margin-left: 20px;line-height: 20px;">图标推荐尺寸120*120</span>
          </div>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addAppCategory, editCategory } from '@/api/categoryManager'
export default {
  props: {
    addDialogVisible: {
      type: Boolean,
      default: false
    },
    propData: {
      type: Object
    }
  },
  data() {
    return {
      form: {
        categoryName: '',
        language: 0,
        pathKey: '',
        fileUrl: ''
      },
      languageOpts: [{
        value: 0,
        label: '中文'
      }, {
        value: 1,
        label: '英文'
      }],
      data: {
        dir: 'category/addBrand/img'
      },
      rules: {
        categoryName: [
          { required: true, message: '品类名称不能为空', trigger: ['blur', 'change'] }
        ],
        language: [
          { required: true, message: '请选择语言', trigger: ['blur', 'change'] }
        ],
        fileUrl: [
          { required: true, message: '请选择图片', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    if (this.propData.categoryId) {
      this.form = this.propData;
    }
  },
  methods: {
    handleImgSuccess(res, file) {
      if (res.code !== 200) {
        this.$message.error('上传出错，请重新上传')
        return
      }
      let {pathKey, fileUrl} = res.data; 
      this.form.pathKey = pathKey;
      this.form.fileUrl = fileUrl;
    },
    beforeImgUp(file) {
      if (file.type.split('/')[1] !== 'png') {
        this.$message.error('上传文件只能是图片格式！')
        return false
      }
      if (file.size / 1024 / 1024 >= 5) {
        this.$message.error('请上传5M以内的图片！')
        return false
      }
      return true
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.propData.categoryId) {
            const params = Object.assign({}, this.form);
            // params.pathKey = '111';
            // params.fileUrl = '111'
            editCategory({ params }).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '编辑完成'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          } else {
            let params = this.form;
            addAppCategory({ params }).then((res) => {
              if (res.data.code === 200 || res.data.code === 0) {
                this.$message({
                  type: 'success',
                  message: '新增成功'
                })
                this.$emit('closeAddDialog', 1)
              }
            })
          }
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$emit('closeAddDialog')
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
}

/deep/.avatar-uploader {
  width: 100px;
  height: 100px;
}

/deep/.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-select {
  width: 100%;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>
